module.exports = __webpack_public_path__ + "img/upgrade-premium-student.d17bf453.svg";